import styles from "./sidebars.module.css";
import {isLoggedIn, isUserAdmin} from "../../services/authService";
import {useGetAllListsQuery} from "../../api/store/anime-lists";
import NavItemIcon from "./sub/navItemIcon";
import {store} from "../../store";
import {openNewAnimeModal} from "../../slices/newAnimeModalSlice";
import {openListModal} from "../../slices/listModalSlice";
import SidebarItem from "./sub/SidebarItem";
import LoadingBars from "../loadingBars";
import AnimeList from "../../models/AnimeList";

const SideNav = () => {
    const  {data: animeListsData, isLoading: isAnimeListsLoading} = useGetAllListsQuery(undefined);

    const pathName= window.location.pathname;

    if (isLoggedIn()) {
        return (
            <>
                <div
                    className="flex-shrink-0 p-3 bg-dark text-light vh-100 overflow-auto"
                    style={{width: "310px"}}
                >
                    <a
                        href="/"
                        className="d-flex align-items-center pb-3 mb-3 text-light text-decoration-none border-bottom border-secondary"
                    >
                        <span className={`fs-5 ${styles.fwSemibold}`}>
                            Personal Anime List
                        </span>
                    </a>

                    <ul className="list-unstyled ps-0">
                        <li className="mb-1">
                            <button
                                className={`
                                    btn 
                                    ${styles.btnToggle} 
                                    ${pathName.includes("profile") && styles.active} 
                                    align-items-center 
                                    rounded 
                                    collapsed 
                                    text-light
                                `}
                                data-bs-toggle="collapse"
                                data-bs-target="#feedback-collapse"
                                aria-expanded="false"
                            >
                                <NavItemIcon iconClass="fa-inbox" style={{marginBottom: "5px"}}/>
                                Feedback
                            </button>

                            <div className="collapse" id="feedback-collapse">
                                <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                    {isUserAdmin() && (
                                        <SidebarItem
                                            iconClass="fa-inbox"
                                            text="Overview"
                                            path="/feedback"
                                        />
                                    )}
                                    <SidebarItem
                                        iconClass="fa-paper-plane"
                                        text="Send feedback"
                                        path="/feedback/send"
                                    />
                                </ul>
                            </div>
                        </li>
                        <li className="mb-1">
                            <button
                                className={`
                                    btn 
                                    ${styles.btnToggle} 
                                    ${pathName.includes("profile") && styles.active} 
                                    align-items-center 
                                    rounded 
                                    collapsed 
                                    text-light
                                `}
                                data-bs-toggle="collapse"
                                data-bs-target="#account-collapse"
                                aria-expanded="false"
                            >
                                <NavItemIcon iconClass="fa-user" style={{marginBottom: "5px"}}/>
                                Account
                            </button>

                            <div className="collapse" id="account-collapse">
                                <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                    <SidebarItem
                                        iconClass="fa-user"
                                        text="Profile"
                                        path="/profile"
                                    />
                                    <SidebarItem
                                        iconClass="fa-sign-out-alt"
                                        text="Logout"
                                        path="/logout"
                                    />
                                </ul>
                            </div>
                        </li>
                        {isUserAdmin() && (
                            <>
                                <li className="mb-1">
                                    <button
                                        className={`
                                            btn 
                                            ${styles.btnToggle} 
                                            ${pathName.includes("genres") && styles.active} 
                                            align-items-center 
                                            rounded 
                                            collapsed 
                                            text-light
                                        `}
                                        data-bs-toggle="collapse"
                                        data-bs-target="#admin-collapse"
                                        aria-expanded="false"
                                    >
                                        <NavItemIcon iconClass="fa-crown" style={{marginBottom: "5px"}}/>
                                        Admin
                                    </button>

                                    <div className="collapse" id="admin-collapse">
                                        <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                            <SidebarItem
                                                iconClass="fa-hat-wizard"
                                                text="Genres"
                                                path="/genres"
                                            />
                                        </ul>
                                    </div>
                                </li>
                                <li className="mb-1">
                                    <button
                                        className={`
                                    btn 
                                    ${styles.btnToggle} 
                                    ${pathName.includes("users") && styles.active} 
                                    align-items-center 
                                    rounded 
                                    collapsed 
                                    text-light
                                `}
                                        data-bs-toggle="collapse"
                                        data-bs-target="#users-collapse"
                                        aria-expanded="false"
                                    >
                                        <NavItemIcon iconClass="fa-users" style={{marginBottom: "5px"}}/>
                                        Users
                                    </button>

                                    <div className="collapse" id="users-collapse">
                                        <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                            <SidebarItem
                                                iconClass="fa-users"
                                                text="Overview"
                                                path="/users"
                                            />
                                            <SidebarItem
                                                iconClass="fa-plus"
                                                text="New"
                                                path="/users/new"
                                            />
                                        </ul>
                                    </div>
                                </li>
                            </>
                        )}


                        <li className="mb-1">
                            <button
                                className={`
                                    btn 
                                    ${styles.btnToggle} 
                                    ${(pathName.includes("anime-lists") || pathName.includes("featured-list")) && styles.active} 
                                    align-items-center 
                                    rounded 
                                    collapsed 
                                    text-light
                                `}
                                data-bs-toggle="collapse"
                                data-bs-target="#lists-collapse"
                                aria-expanded="false"
                            >
                                <NavItemIcon iconClass="fa-book-skull" style={{marginBottom: "5px"}}/>
                                Lists
                            </button>

                            <div className="collapse" id="lists-collapse">
                                <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                    {isAnimeListsLoading ?
                                        <LoadingBars/> :
                                        animeListsData && animeListsData.lists.map((list: AnimeList) => (
                                            <SidebarItem
                                                iconClass="fa-scroll"
                                                text={list.title}
                                                path={`/anime-lists/${list.slug}`}
                                            />
                                        ))
                                    }
                                    <li>
                                        <hr className="dropdown-divider"
                                            style={{height: "1px", color: "white", backgroundColor: "white"}}/>
                                    </li>
                                    <SidebarItem
                                        iconClass="fa-book-skull"
                                        text="Overview"
                                        path="/anime-lists"
                                    />
                                    <SidebarItem
                                        iconClass="fa-upload"
                                        text="Import MAL"
                                        path="/anime-lists/import/mal"
                                    />
                                    <SidebarItem
                                        iconClass="fa-plus"
                                        text="New"
                                        onClick={() => {
                                            store.dispatch(openListModal());
                                        }}
                                    />
                                    <SidebarItem
                                        iconClass="fa-star"
                                        text="Featured"
                                        path="/featured-list"
                                    />
                                </ul>
                            </div>
                        </li>

                        <li className="mb-1">
                            <button
                                className={`
                                btn 
                                ${styles.btnToggle} 
                                ${(pathName.includes("seasons") || pathName.includes("api")) && styles.active} 
                                align-items-center 
                                rounded 
                                collapsed 
                                text-light
                                `}
                                data-bs-toggle="collapse"
                                data-bs-target="#anime-collapse"
                                aria-expanded="false"
                            >
                                <NavItemIcon iconClass="fa-leaf" style={{marginBottom: "5px"}}/>
                                Anime
                            </button>

                            <div className="collapse" id="anime-collapse">
                                <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                    <SidebarItem
                                        iconClass="fa-icicles"
                                        text="Seasons"
                                        path="/seasons"
                                    />
                                    {isUserAdmin() && (
                                        <>
                                            <SidebarItem
                                                iconClass="fa-link"
                                                text="API"
                                                path="/api"
                                            />
                                            <SidebarItem
                                                iconClass="fa-plus"
                                                text="New"
                                                onClick={() => {
                                                    store.dispatch(openNewAnimeModal());
                                                }}
                                            />
                                        </>
                                    )}
                                </ul>
                            </div>
                        </li>
                        <li className="mb-1">
                            <button
                                className={`
                                btn 
                                ${styles.btnToggle} 
                                ${pathName.includes("search") && styles.active} 
                                align-items-center 
                                rounded 
                                collapsed 
                                text-light
                                `}
                                data-bs-toggle="collapse"
                                data-bs-target="#search-collapse"
                                aria-expanded="false"
                            >
                                <NavItemIcon iconClass="fa-magnifying-glass" style={{marginBottom: "5px"}}/>
                                Search
                            </button>

                            <div className="collapse" id="search-collapse">
                                <ul className={`${styles.btnToggleNav} list-unstyled fw-normal pb-1 small`}>
                                    <SidebarItem
                                        iconClass="fa-leaf"
                                        text="Anime"
                                        path="/search"
                                    />
                                    <SidebarItem
                                        iconClass="fa-book-skull"
                                        text="Listed anime"
                                        path="/search/listed-anime"
                                    />
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </>
        );
    }

    return <></>
};

export default SideNav;
